import React from "react";
import { capitalizeFirstLetter } from "../UserProfile";
import { formatDate } from "../../../../../../CommonFunction/FormatedDate";
import { HiArrowNarrowLeft, HiShieldCheck } from "react-icons/hi";

export const formatString = (userData) => {
  const words = userData?.type ? userData.type.split("_") : [];
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  const formattedString = capitalizedWords.join(" ");
  return formattedString;
};

const OrganizationProfile = ({ userData, onClose }) => {
  const openInNewTab = (url) => {
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="mt-10">
        <div className="pb-2 lg:mx-14 mx-2">
          <div className="flex justify-between pb-3">
            <div className="flex">
              <h1 className="text-2xl font-bold text-bgclr">
                Organization Details
              </h1>
            </div>
            <div className="text-md">
              <button
                className="flex items-center text-gray-500 border border-gray-400 px-3 py-1.5 rounded-md bg-bgclr9"
                onClick={onClose}
              >
                <HiArrowNarrowLeft /> Back
              </button>
            </div>
          </div>

          <div className="mt-3 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
            <div>
              <div>
                <h2 className="text-[18px] font-semibold text-txt-clr2">
                  BASIC INFORMATION
                </h2>
              </div>
              <div className="leading-7 ">
                <div className="flex">
                  <h2 className="text-[16px] text-gray-500 w-[18%]">Name: </h2>
                  <h2 className="pl-5">
                    {capitalizeFirstLetter(userData?.name)}{" "}
                  </h2>
                </div>
                <div className="flex">
                  <h2 className="text-[16px] text-gray-500 w-[18%]">
                    Organization Type:{" "}
                  </h2>
                  <h2 className="pl-5">{formatString(userData)}</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="lg:w-[50%] mt-3 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
              <div>
                <div>
                  <h2 className="text-[18px] font-semibold text-txt-clr2">
                    CONTACT DETAILS
                  </h2>
                </div>
                <div className="leading-7">
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[20%]">
                      Email ID:{" "}
                    </h2>
                    <h2 className="flex pl-5">
                      {userData?.email}{" "}
                      {userData?.email && (
                        <HiShieldCheck
                          size={18}
                          className="mt-1 ml-1 text-green-700"
                        />
                      )}
                    </h2>
                  </div>
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[20%]">
                      Phone:{" "}
                    </h2>
                    <h2 className="flex pl-5">
                      {userData?.phone_number}{" "}
                      {userData?.phone_number && (
                        <HiShieldCheck
                          size={18}
                          className="mt-1 ml-1 text-green-700"
                        />
                      )}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-[50%] mt-3 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
              <div>
                <div>
                  <h2 className="text-[18px] font-semibold text-txt-clr2">
                    AUTHORIZED PERSON
                  </h2>
                </div>
                <div className="leading-7">
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[25%]">
                      Name:{" "}
                    </h2>
                    <h2 className="pl-5">
                      {capitalizeFirstLetter(userData?.authorized_person)}
                    </h2>
                  </div>
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[25%]">
                      Designation:{" "}
                    </h2>
                    <h2 className="pl-5">
                      {capitalizeFirstLetter(userData?.designation)}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-6">
            <div className="lg:w-[50%] mt-3 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
              <div>
                <div>
                  <h2 className="text-[18px] font-semibold text-txt-clr2">
                    DOCUMENTS
                  </h2>
                </div>
                <div className="leading-7">
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[30%]">
                      GST Number:{" "}
                    </h2>
                    <h2 className="flex pl-5">
                      {userData?.personal.gst_number}{" "}
                      {userData?.personal.gst_number && (
                        <HiShieldCheck
                          size={18}
                          className="mt-1 ml-1 text-green-700"
                        />
                      )}
                    </h2>
                  </div>
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[30%]">
                      PAN Number:{" "}
                    </h2>
                    <h2 className="flex pl-5">
                      {userData?.personal.pancard}{" "}
                      {userData?.personal.pancard && (
                        <HiShieldCheck
                          size={18}
                          className="mt-1 ml-1 text-green-700"
                        />
                      )}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-[50%] mt-3 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
              <div>
                <div>
                  <h2 className="text-[18px] font-semibold text-txt-clr2">
                    ALTERNATE INFORMATION
                  </h2>
                </div>
                <div className="leading-7">
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[35%]">
                      Phone Number:{" "}
                    </h2>
                    <h2 className="pl-5">
                      {userData?.alternate_contacts.phone_number}
                    </h2>
                  </div>
                  <div className="flex">
                    <h2 className="text-[16px] text-gray-500 w-[35%]">
                      Email ID:{" "}
                    </h2>
                    <h2 className="pl-5">
                      {userData?.alternate_contacts.email}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
            <div>
              <div>
                <h2 className="text-[18px] font-semibold text-txt-clr2">
                  ADDRESS
                </h2>
              </div>
              <div className="leading-7">
                <div className="flex">
                  <h2 className="text-[16px] text-gray-500 w-[20%]">
                    Office Address:{" "}
                  </h2>
                  <h2 className="pl-5">{userData?.address.office_address}</h2>
                </div>
                <div className="flex">
                  <h2 className="text-[16px] text-gray-500 w-[20%]">
                    Registered Address:{" "}
                  </h2>
                  <h2 className="pl-5">
                    {userData?.address.registered_address}
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
            <div>
              <div>
                <h2 className="text-[18px] font-semibold text-txt-clr2">
                  Linked Loans
                </h2>
              </div>
              <div className="leading-7 mt-2">
                <div className="flex">
                  <h2 className="text-[16px] text-gray-500 w-[10%]">Loans: </h2>
                  <h2 className="pl-5">
                    {userData?.linked_loans.map((data, index) => (
                      <div key={index}>{data}</div>
                    ))}
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 bg-bgclr9 px-5 py-3 border border-gray-400 rounded-md">
            <div>
              <h2 className="text-[18px] font-semibold text-txt-clr2">
                MORE ACTION
              </h2>
            </div>
            <div className="mt-2 mb-2">
              {userData?.invoice?.map((data, index) => (
                <div className="mt-4 flex justify-between items-center">
                  <div className="flex items-center gap-5">
                    <div className="bg-bgclr p-3 rounded-md">
                      <svg
                        width="23"
                        height="29"
                        viewBox="0 0 23 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.5 2.125C0.5 1.76033 0.644866 1.41059 0.902728 1.15273C1.16059 0.894866 1.51033 0.75 1.875 0.75H21.125C21.4897 0.75 21.8394 0.894866 22.0973 1.15273C22.3551 1.41059 22.5 1.76033 22.5 2.125V26.875C22.5 27.1379 22.4247 27.3952 22.283 27.6166C22.1412 27.8379 21.939 28.014 21.7002 28.124C21.4615 28.2339 21.1962 28.2732 20.9359 28.237C20.6755 28.2009 20.431 28.0909 20.2313 27.92L18.8109 26.7031C18.5617 26.4897 18.2445 26.3724 17.9164 26.3724C17.5884 26.3724 17.2712 26.4897 17.022 26.7031L15.603 27.9186C15.3538 28.1324 15.0362 28.2499 14.7079 28.2499C14.3795 28.2499 14.062 28.1324 13.8127 27.9186L12.3951 26.7031C12.1459 26.4894 11.8284 26.3719 11.5 26.3719C11.1716 26.3719 10.8541 26.4894 10.6049 26.7031L9.18725 27.9186C8.938 28.1324 8.62048 28.2499 8.29212 28.2499C7.96377 28.2499 7.64625 28.1324 7.397 27.9186L5.978 26.7031C5.72885 26.4897 5.41161 26.3724 5.08356 26.3724C4.75552 26.3724 4.43828 26.4897 4.18913 26.7031L2.77012 27.9186C2.5705 28.0898 2.32596 28.2002 2.0655 28.2366C1.80505 28.2731 1.53962 28.234 1.30067 28.1242C1.06172 28.0143 0.859286 27.8383 0.717373 27.6169C0.57546 27.3955 0.50002 27.138 0.5 26.875V2.125ZM7.375 6.25C7.01033 6.25 6.66059 6.39487 6.40273 6.65273C6.14487 6.91059 6 7.26033 6 7.625C6 7.98967 6.14487 8.33941 6.40273 8.59727C6.66059 8.85513 7.01033 9 7.375 9H15.625C15.9897 9 16.3394 8.85513 16.5973 8.59727C16.8551 8.33941 17 7.98967 17 7.625C17 7.26033 16.8551 6.91059 16.5973 6.65273C16.3394 6.39487 15.9897 6.25 15.625 6.25H7.375ZM7.375 11.75C7.01033 11.75 6.66059 11.8949 6.40273 12.1527C6.14487 12.4106 6 12.7603 6 13.125C6 13.4897 6.14487 13.8394 6.40273 14.0973C6.66059 14.3551 7.01033 14.5 7.375 14.5H15.625C15.9897 14.5 16.3394 14.3551 16.5973 14.0973C16.8551 13.8394 17 13.4897 17 13.125C17 12.7603 16.8551 12.4106 16.5973 12.1527C16.3394 11.8949 15.9897 11.75 15.625 11.75H7.375ZM8.75 18.625C8.75 18.2603 8.89487 17.9106 9.15273 17.6527C9.41059 17.3949 9.76033 17.25 10.125 17.25H15.625C15.9897 17.25 16.3394 17.3949 16.5973 17.6527C16.8551 17.9106 17 18.2603 17 18.625C17 18.9897 16.8551 19.3394 16.5973 19.5973C16.3394 19.8551 15.9897 20 15.625 20H10.125C9.76033 20 9.41059 19.8551 9.15273 19.5973C8.89487 19.3394 8.75 18.9897 8.75 18.625Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <h3 className="text-[18px] font-[500]">
                      Download Invoice <span>[{formatDate(data?.date)}]</span>
                    </h3>
                  </div>
                  <div>
                    <button
                      onClick={() => openInNewTab(data?.url)}
                      className="bg-bgclr text-txtclr rounded-md px-3 py-1.5"
                    >
                      Download
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganizationProfile;
